/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Badge_BlockedInputs */

const fr_calendar_quota_badge_blocked = /** @type {(inputs: Calendar_Quota_Badge_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqué`)
};

/**

* @param {Calendar_Quota_Badge_BlockedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_badge_blocked = /** @type {((inputs?: Calendar_Quota_Badge_BlockedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Badge_BlockedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_badge_blocked(inputs)
});